import GenericRequest, { METHOD_PUT } from '../../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';

export class TaskCreateTask extends GenericRequest {

    _request; // TaskCreateRequest

    constructor(request) {
        super(METHOD_PUT, ApiEndpoints.TASK_ADD);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/form/create/ws/TaskCreateTask.js